// TODO: Add propTypes
/* eslint-disable react/prop-types */
import React from 'react';
import cx from 'classnames';
import { ButtonIcon } from '@companycam/slab-web';

const StyleButton = ({
  ariaLabel,
  children,
  onToggle,
  onMouseDown,
  style,
  active,
  label,
  icon,
  color,
}) => {
  const handleToggle = (e) => {
    e.preventDefault();

    if (typeof onMouseDown === 'function') {
      onMouseDown();
    }

    if (typeof onToggle === 'function') {
      onToggle(style);
    }
  };

  const classes = cx('RichEditor-button', {
    active,
  });

  return (
    <div className="hint--top-right" aria-label={ariaLabel}>
      <ButtonIcon
        color={color || 'secondary'}
        size="small"
        iconName={icon}
        design="minimal"
        className={classes}
        onMouseDown={handleToggle}
        title={label}
        accessibilityLabel={label}
      >
        {children}
      </ButtonIcon>
    </div>
  );
};

export default StyleButton;
